import { SimpleButton } from '@apia/components';
import { CollectorField } from '../CollectorField';
import { ButtonProps } from '@apia/theme';

let i = 0;

export class CollectorButton extends CollectorField<
  null,
  Omit<ButtonProps, 'children'>
> {
  type = 'button';

  constructor(
    protected label: string,
    properties?: Omit<ButtonProps, 'children'>,
  ) {
    super(`Button${i++}`, label, properties);
  }

  Component = () => {
    const props = this.useProperties();

    return <SimpleButton {...props}>{this.label}</SimpleButton>;
  };
}
